import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d1735580&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=d1735580&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1735580",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1735580')) {
      api.createRecord('d1735580', component.options)
    } else {
      api.reload('d1735580', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d1735580&scoped=true&", function () {
      api.rerender('d1735580', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UI/CaseOpening/index.vue"
export default component.exports